import firebaseApp from "../../firebase/credenciales";
import { getFirestore, deleteDoc, collection, doc } from "firebase/firestore";
import escribirLog from "../escribirLog";
const db = getFirestore(firebaseApp);

export default async function eliminarPago(producto) {
  console.log(producto)
  const coleccionRef = collection(db, "Proveedores_pagos/"+producto.nombre+"/Productos/".replace(/ /g, ""));
  const docuRef = doc(coleccionRef, producto.fecha);
  const eliminado = await deleteDoc(docuRef);

  //escribirLog("Eliminación", producto, usuario);

  return eliminado;
}
